<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="item && prevRoute && prevRoute.name === 'EXCMSlaShow'" :to="{ name: 'EXCMSlaShow', params: { id: retrieved['@id'] }}" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToShow')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMSlaList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmsla.update.title')}} {{ item && item['title'] }}</h4>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMSlaForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMSlaForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMSlaForm,
    Loader
  },

  data () {
    return {
      prevRoute: null,
      item: {}
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmsla/update/isLoading',
      error: 'excmsla/update/error',
      deleteError: 'excmsla/del/error',
      deleteLoading: 'excmsla/del/isLoading',
      created: 'excmsla/create/created',
      deleted: 'excmsla/del/deleted',
      retrieved: 'excmsla/update/retrieved',
      updated: 'excmsla/update/updated',
      violations: 'excmsla/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMSlaList' })
    },

    updated: function (updated) {
      this.$Swal({
        title: updated.title + ' ' + this.$t('notifications.updated'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
      this.$router.push({ name: 'EXCMSlaShow', params: { id: updated['@id'] } })
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmsla/create/reset',
      deleteItem: 'excmsla/del/del',
      delReset: 'excmsla/del/reset',
      retrieve: 'excmsla/update/retrieve',
      updateReset: 'excmsla/update/reset',
      update: 'excmsla/update/update',
      updateRetrieved: 'excmsla/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmsla ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
